module.exports = __webpack_public_path__ + "static/talks2-6f1f33c6f55a99188e98cef282ae0e2c.png";